import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Route, Routes } from 'react-router-dom';

import { AppContextProvider } from 'context/AppContext';
import { AnnouncementsProvider } from 'context/AnnouncementsContext';
import useUser from 'hooks/useUser';
import { MainRoutes } from 'helpers/routes';

import AppHeader from 'components/layout/AppHeader';
import AppContainer from 'components/layout/AppContainer';
import UnauthorizedPage from 'components/layout/UnauthorizedPage';
import Snackbar from 'components/elements/Snackbar';

import BurnCentersPage from 'pages/burn-centers';
import UsersPage from 'pages/users';
import VerificationPage from 'pages/verification';
import ReportsPage from 'pages/reports';
import UploadPage from 'pages/uploads';
import TrainingPage from 'pages/training';
import HomePage from 'pages/home/HomePage';
import AdminPage from 'pages/admin';
import BedBoardRoutes from 'pages/bed-board';
import UpdatesRoutes from 'pages/updates';
import ProfilePage from './profile';

const AppRoutes = () => {
  const { hasVerification, hasReports } = useUser();

  return (
    <AppContextProvider>
      <AnnouncementsProvider>
        <AppContainer>
          <AppHeader />
          <div
            id="app-main-scroll"
            style={{
              display: 'flex',
              flex: 1,
              flexDirection: 'column',
              minHeight: 0,
              overflow: 'auto',
            }}
          >
            <Routes>
              <Route index element={<HomePage />} />
              <Route
                path={`${MainRoutes.UPDATES}/*`}
                element={<UpdatesRoutes />}
              />
              <Route
                path={`${MainRoutes.BED_BOARD}/*`}
                element={<BedBoardRoutes />}
              />
              {hasVerification && (
                <Route
                  path={`${MainRoutes.VERIFICATION}/*`}
                  element={<VerificationPage />}
                />
              )}
              <Route
                path={`${MainRoutes.PROFILE}/*`}
                element={<ProfilePage />}
              />
              <Route path={`${MainRoutes.ADMIN}/*`} element={<AdminPage />} />
              <Route
                path={`${MainRoutes.BURN_CENTERS}/*`}
                element={<BurnCentersPage />}
              />
              <Route path={`${MainRoutes.USERS}/*`} element={<UsersPage />} />
              {hasReports && (
                <Route
                  path={`${MainRoutes.REPORTS}/*`}
                  element={<ReportsPage />}
                />
              )}
              <Route path={`${MainRoutes.UPLOAD}/*`} element={<UploadPage />} />
              <Route
                path={`${MainRoutes.TRAINING}/*`}
                element={<TrainingPage />}
              />
              <Route path="*" element={<UnauthorizedPage />} />
            </Routes>
          </div>
          <Snackbar />
        </AppContainer>
      </AnnouncementsProvider>
    </AppContextProvider>
  );
};

export default withAuthenticationRequired(AppRoutes);
